// src/components/layouts/admindashboard/index.tsx
import React, { useEffect } from 'react';
import { Outlet } from "react-router-dom";
import Sidebar from './sidebar';
import Header from './header';
import { Toaster } from 'react-hot-toast';
import { MobileMenuProvider } from '../../../context/MobileMenuContext';

export const AdminLayout: React.FC = () => {
  useEffect(() => {
    // Pas besoin de gérer le scroll ici, on le fera dans le Sidebar
  }, []);

  return (
    <MobileMenuProvider>
      <div className="flex h-screen font-poppins">
        <Sidebar />
        <div className="flex flex-1 flex-col lg:ml-[260px]">
          <Header />
          <main className="flex-1 overflow-y-auto persosrcollbar bg-gradient-to-br from-black to-green-950 p-2 sm:p-8 w-full mx-auto">
            <Outlet />
          </main>
        </div>
        <Toaster position="top-right" />
      </div>
    </MobileMenuProvider>
  );
};

export default AdminLayout;